import React from "react";
import { HOME } from "@/constants/testIds";

export default function AncientWisdom({ copy, onBook }) {
  return (
    <section className="py-20 md:py-28">
      <div className="mx-auto max-w-[900px] px-5 md:px-10 text-center">
        <div className="eyebrow">Rooted in ancient wisdom</div>
        <h2 className="font-serif-ev mt-4 text-4xl sm:text-5xl md:text-6xl leading-[1.02] tracking-tight">
          Healing began centuries ago — now it begins with{" "}
          <span className="italic" style={{ color: "#C7A76A" }}>you.</span>
        </h2>
        <p className="mt-6 text-[15px] md:text-lg max-w-2xl mx-auto" style={{ color: "var(--ev-muted)" }}>
          {copy}
        </p>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a href="#about" className="ev-btn ev-btn-outline">Meet Prriyanka</a>
          <button data-testid={HOME.stepsBookBtn} onClick={onBook} className="ev-btn ev-btn-primary">
            Book a free session
          </button>
        </div>
      </div>
    </section>
  );
}
